import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20",
  class: "verification_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.395 1.11a.8.8 0 0 1 1.21 0l1 1.16a.8.8 0 0 0 .869.233l1.447-.504a.8.8 0 0 1 1.048.605l.286 1.505a.8.8 0 0 0 .636.635l1.505.287A.8.8 0 0 1 18 6.08l-.504 1.447a.8.8 0 0 0 .232.868l1.16 1.001a.8.8 0 0 1 0 1.21l-1.16 1.001a.8.8 0 0 0-.232.868L18 13.921a.8.8 0 0 1-.605 1.048l-1.505.287a.8.8 0 0 0-.636.635l-.287 1.505a.8.8 0 0 1-1.047.605l-1.447-.504a.8.8 0 0 0-.868.233l-1.001 1.16a.8.8 0 0 1-1.21 0l-1.001-1.16a.8.8 0 0 0-.868-.233l-1.447.504a.8.8 0 0 1-1.048-.605l-.287-1.505a.8.8 0 0 0-.635-.635l-1.505-.287a.8.8 0 0 1-.605-1.048l.503-1.447a.8.8 0 0 0-.232-.868l-1.16-1a.8.8 0 0 1 0-1.211l1.16-1.001a.8.8 0 0 0 .232-.868L2 6.079a.8.8 0 0 1 .605-1.048l1.505-.287a.8.8 0 0 0 .635-.635l.287-1.505a.8.8 0 0 1 1.048-.605l1.447.504a.8.8 0 0 0 .868-.233l1-1.16Zm4.355 5.14L15 7.5l-6.25 6.25L5 10l1.25-1.25 2.5 2.5 5-5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }